import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import moment from 'moment'
import { DocumentEntryItem } from 'src/app/components/documents/documents.component'
import { DocumentType } from 'src/domain/document'
import { DOCUMENT_TYPE_IDCARD, IDCARD_META } from './idcard-render.constants'
import { bumpIdNumberYear } from './idcard-number.util'

const EXPIRY_TIME_FORMAT = 'yyyy.MM.DD.'

export interface IdCardRenewState {
  idCardType: keyof typeof IDCARD_META
  trainerName: string
  idNumber: string
  expiryText: string
  clientPhotoUrl: string
}

@Injectable({ providedIn: 'root' })
export class IdCardRenewService {
  constructor(private router: Router) {}

  canRenew(document: DocumentEntryItem): boolean {
    return !!document.idCard?.clientPhotoUrl && !!DOCUMENT_TYPE_IDCARD[document.type as DocumentType]
  }

  /**
   * Navigates to the idcard editor prefilled with the bumped id number/expiry, so the user
   * finishes the renewal manually (photo, download, save & upload) the same way as a new card.
   */
  renew(dogId: string, document: DocumentEntryItem): boolean {
    if (!this.canRenew(document)) {
      return false
    }

    const docType = document.type as DocumentType
    const idCardType = DOCUMENT_TYPE_IDCARD[docType]
    const newIdNumber = bumpIdNumberYear(document.idCard.idNumber, moment().format('YY'))
    const newExpiry = moment().add(365, 'days').format(EXPIRY_TIME_FORMAT)

    const renewState: IdCardRenewState = {
      idCardType,
      trainerName: document.idCard.trainer,
      idNumber: newIdNumber,
      expiryText: newExpiry,
      clientPhotoUrl: document.idCard.clientPhotoUrl,
    }

    this.router.navigate(['dog', dogId, 'idcard'], { state: { renewState } })
    return true
  }
}
